import { render, staticRenderFns } from "./MedicineIndicationsForm.vue?vue&type=template&id=3ec1e9de"
import script from "./MedicineIndicationsForm.vue?vue&type=script&lang=js"
export * from "./MedicineIndicationsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports